import { render, staticRenderFns } from "./LocationDetailView.vue?vue&type=template&id=51afdda3&scoped=true&"
import script from "./LocationDetailView.vue?vue&type=script&lang=js&"
export * from "./LocationDetailView.vue?vue&type=script&lang=js&"
import style0 from "./LocationDetailView.vue?vue&type=style&index=0&id=51afdda3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afdda3",
  null
  
)

/* custom blocks */
import block0 from "./LocationDetailView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports